import { mapEnumToOptions } from '@abp/ng.core';

export enum OrderState {
  Delivered = 0,
  New = 1,
  Approved = 2,
  Rejected = 3,
  Received = 4,
}

export const orderStateOptions = mapEnumToOptions(OrderState);
